/**
 * @deprecated please use @link #simpleFileDownload(requestUrl)
 * @param response response
 * @param mimeType mime type
 */
export const downloadFile = function (response, mimeType) {
    let fileName = response.headers["content-disposition"].split("filename=")[1];
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
        window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: mimeType}), fileName);
    } else {
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
};

export const simpleFileDownload = function (requestUrl) {
    window.location.href = requestUrl;
};

// Reference: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
export const mimeTypes = {

    // Text:
    css: 'text/css',
    csv: 'text/csv',
    html: 'text/html',
    js: 'text/javascript',
    txt: 'text/plain',
    xml: 'text/xml',
    rtf: 'application/rtf',
    epub: 'application/epub+zip',
    pdf: 'application/pdf',

    // Archive:
    bz: 'application/x-bzip',
    bz2: 'application/x-bzip2',
    gz: 'application/gzip',
    jar: 'application/java-archive',
    rar: 'application/x-rar-compressed',
    tar: 'application/x-tar',
    zip: 'application/zip',
    sevenz: 'application/x-7z-compressed',

    // Image:
    bmp: 'image/bmp',
    gif: 'image/gif',
    jpg: 'image/jpeg',
    png: 'image/png',
    svg: 'image/svg+xml',
    tif: 'image/tiff',
    webp: 'image/webp',

    // Microsoft Office:
    doc: 'application/msword',
    xls: 'application/vnd.ms-excel',
    ppt: 'application/vnd.ms-powerpoint',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',

};

const DownloadService = {
    downloadFile,
    downloadFileInNewTab: simpleFileDownload,
    mimeTypes
};
